import React, { useState, useEffect } from 'react';

const ThankYouPage = () => {
    const [paymentDetails, setPaymentDetails] = useState(null);

    useEffect(() => {
        document.title = "CFM Payments - Thank You";

        const storedDetails = localStorage.getItem('paymentDetails');
        if (storedDetails) {
            setPaymentDetails(JSON.parse(storedDetails));
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
            <div className="max-w-2xl bg-white rounded-md border border-blue-300 p-6">
                <div className="flex flex-col items-center mb-6">
                    <div className="mb-4">
                        <img
                            src="/images/cfm_logo_white.png"
                            alt="Contract Furnishings Mart"
                            className="h-32 mb-1"
                        />
                    </div>
                    <div className="default-blue font-bold text-xl">
                        Thank you!
                    </div>
                </div>

                <p className="text-black mb-6">
                    Your payment has been received. A confirmation will be sent shortly.
                </p>

                {paymentDetails ? (
                    <div className="space-y-3">
                        <div className="grid grid-cols-2">
                            <div>Date:</div>
                            <div>{new Date(paymentDetails.date).toLocaleDateString('en-US', {
                                month: 'numeric',
                                day: 'numeric',
                                year: 'numeric'
                            })}</div>
                        </div>

                        <div className="grid grid-cols-2">
                            <div>Invoice #:</div>
                            <div>
                                {paymentDetails.invoices.map((invoice, index) => (
                                    <div key={index} className="text-blue-500">{invoice}</div>
                                ))}
                            </div>
                        </div>

                        <div className="grid grid-cols-2">
                            <div>Payment Method:</div>
                            <div>{paymentDetails.paymentMethod}</div>
                        </div>

                        <div className="grid grid-cols-2">
                            <div>Total Payment Amount:</div>
                            <div>${parseFloat(paymentDetails.totalAmount).toFixed(2)}</div>
                        </div>
                    </div>
                ) : (
                    <div className="space-y-3">
                        <div className="grid grid-cols-2">
                            <div>Date:</div>
                                <div>{new Date().toLocaleDateString('en-US', {
                                    month: 'numeric',
                                    day: 'numeric',
                                    year: 'numeric'
                                })}</div>
                        </div>

                        <div className="grid grid-cols-2">
                            <div>Invoice #:</div>
                            <div>
                                <div className="text-blue-500">No invoice information available</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2">
                            <div>Payment Method:</div>
                            <div>Not available</div>
                        </div>

                        <div className="grid grid-cols-2">
                            <div>Total Payment Amount:</div>
                            <div>$0.00</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ThankYouPage;